import clsx from 'clsx'

import MonacoEditor, { MonacoEditorProps } from './monaco-editor'

export type MonacoEditorInputProps = MonacoEditorProps & {
  /**
   * The default language to use for Monaco (eg. json, graphql, javascript)
   */
  language: string
  className?: string
  id?: string
  minHeight?: number
  options?: any
  hasErrors?: boolean
  value?: string
}

/**
 * A react-hook-form connected component for MonacoEditor
 */
export const MonacoEditorInput = ({ language, className, value, hasErrors, ...rest }: MonacoEditorInputProps) => {
  let transformedValue = value

  try {
    const parsed = JSON.parse(value ?? '[]')

    if (Array.isArray(parsed)) {
      for (const item of parsed) {
        if (Array.isArray(item.conditions)) {
          item.conditions = item.conditions.map((cond: string) => {
            const match = cond.match(/^Condition\((.*)\)$/)
            if (match && match[1]) {
              try {
                return JSON.parse(match[1])
              } catch {
                return cond
              }
            }
            return cond
          })
        }
      }
    }

    transformedValue = JSON.stringify(parsed, null, 2)
  } catch {
    // Not a JSON string, so use it as-is (e.g. SQL query)
  }

  return (
    <MonacoEditor
      {...rest}
      className={clsx(
        // NOTE: Used to have max width here to prevent resize bug, but seems ok now...
        hasErrors && 'ring-brand ring ring-2',
        className,
      )}
      src={transformedValue}
      language={language}
      readOnly={false}
    />
  )
}

export default MonacoEditorInput
